import { FC } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { Title } from "common/components/Title/Title";
import { List } from "common/components/List/List";
import { removePhotoAt } from "features/ordering/orderingSlice";
import { SvgTrash } from "assets/icons/SvgTrash";
import styles from "./ordering.module.scss";

export const LoadedImages: FC = () => {
  const dispatch = useAppDispatch();
  const photos = useAppSelector((state) => state.ordering.photos);

  const photoArr =
    photos && Array.from(photos).map((file) => URL.createObjectURL(file));

  const handleRemove = (index: number) => {
    dispatch(removePhotoAt(index));
  };

  return (
    <div className="pointer-events-auto flex h-fit max-h-[100%] max-w-[400px] flex-col overflow-y-auto rounded bg-white p-[15px]">
      <Title className="mb-[15px] text-center">Загруженные фото</Title>
      <List>
        {photoArr?.map((image, index) => (
          <div
            key={`${index}-${image}`}
            className={`relative h-[222px] ${styles.imageWrapper}`}
          >
            <img
              className="h-full w-full rounded object-cover"
              src={image}
              alt="Загруженное фото"
            />
            <div className={styles.imageButtonWrapper}>
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className={`rounded-full absolute bg-primary text-white focus:outline-none ${styles.imageButton}`}
                aria-label="Удалить фото"
              >
                <SvgTrash className="h-6 w-6" />
              </button>
            </div>
          </div>
        ))}
      </List>
    </div>
  );
};
